export default __webpack_public_path__ + "static/media/studentfacingside.1a0471c6.svg";